import { action } from 'typesafe-actions';

export function changeTheme(theme: string) {
  return action('@theme/CHANGE_THEME', {
    theme,
  });
}

export default changeTheme;
